export enum UserGeneratedDonutGroup {
	FAILURES = 'failures',
	DISTANCE = 'distance',
	PRODUCTIVITY = 'productivity',
	PICKUP_STATIONS = 'pickup_stations',
	DROP_STATIONS = 'drop_stations',
	ORDERS = 'orders',
}
